import { action } from 'satcheljs';

export const popOutComposeForm = action('popOutComposeForm');

export const closeComposeFormInTimePanel = action('closeComposeFormInTimePanel');
